const isLead = (location) => {
    const paths = location.pathname.split('/')

    if(paths.length < 3) {
      return false
    }

    return paths[1] === 'lead' && paths[2] === 'confirm'
}

export default isLead


// WEBPACK FOOTER //
// ./src/utils/isLead.js